/**
=========================================================
* Material Dashboard 3 PRO React - v2.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useState, useEffect } from "react";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ProfileInfoCard from "examples/Cards/InfoCards/ProfileInfoCard";

import ProfilesList from "layouts/pages/profile/profile-overview/components/ProfilesList";
import DefaultProjectCard from "examples/Cards/ProjectCards/DefaultProjectCard";

// Overview page components
import Header from "layouts/pages/profile/components/Header";
import PlatformSettings from "layouts/pages/profile/profile-overview/components/PlatformSettings";

// Images
import homeDecor1 from "assets/images/bg-player.jpeg";

import axios from "axios";
import { useParams } from "react-router-dom";
import { API_ESA_OFFICE } from "utils";
import { logoutUser } from "actions/AuthAction";
import { useNavigate } from "react-router-dom";

function User_Overview() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [userId, setUserId] = useState(null);
  const [dinasId, setDinasId] = useState(null);
  const [userDetail, setUserDetail] = useState(null);
  const [tugas, setTugas] = useState([]);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserId(user.uid);
      setDinasId(user.dinas_id);
    } else {
      logoutUser(navigate);
    }
  }, []);

  // Fungsi untuk mengubah teks menjadi proper case
  const toProperCase = (text) => {
    if (!text) return "";
    return text
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  useEffect(() => {
    if (id) {
      fetchUserDetail();
      fetchTugas();
    }
  }, [id]);

  const fetchTugas = async () => {
    try {
      const response = await axios.get(`${API_ESA_OFFICE}users/tugas/${id}`);
      setTugas(response.data);
    } catch (error) {
      console.error("Error fetching tugas:", error);
    }
  };

  const fetchUserDetail = async () => {
    try {
      const response = await axios.get(`${API_ESA_OFFICE}users/detail/${id}`);
      setUserDetail(response.data);
      console.log("userDetail", response.data);
    } catch (error) {
      console.error("Error fetching user detail:", error);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <Header
        userNama={userDetail && userDetail.nama}
        userJabatan={userDetail && userDetail.nama_jabatan}
        profile={
          userDetail &&
          `https://smartdh.rotendaokab.go.id/uploads/${userDetail.uid_RSS}.jpg`
        }
      >
        <MDBox mt={5} mb={3}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6} xl={4}>
              <PlatformSettings />
            </Grid>
            <Grid item xs={12} md={6} xl={4} sx={{ display: "flex" }}>
              <Divider orientation="vertical" sx={{ ml: -2, mr: 1 }} />
              <ProfileInfoCard
                title="profile information"
                description="Seorang Aparatur Sipil Negara yang berdedikasi tinggi, selalu berkomitmen untuk memberikan pelayanan terbaik kepada masyarakat dan berkontribusi positif dalam pembangunan bangsa."
                info={{
                  fullName: userDetail && toProperCase(userDetail.nama),
                  mobile: userDetail && userDetail.no_hp,
                  email: userDetail && userDetail.email,
                  Dinas: userDetail && toProperCase(userDetail.nama_dinas),
                }}
                social={[
                  {
                    link: `https://www.facebook.com/${
                      userDetail && userDetail.facebook
                    }`,
                    icon: <FacebookIcon />,
                    color: "facebook",
                  },
                  {
                    link: `https://twitter.com/${
                      userDetail && userDetail.instagram
                    }`,
                    icon: <InstagramIcon />,
                    color: "instagram",
                  },
                ]}
                action={{ route: "", tooltip: "Edit Profile" }}
                shadow={false}
              />
              <Divider orientation="vertical" sx={{ mx: 0 }} />
            </Grid>
            <Grid item xs={12} xl={4}>
              <ProfilesList
                title={userDetail && userDetail.nama_bidang}
                profiles={userDetail ? userDetail.teman_bidang : []}
                shadow={false}
              />
            </Grid>
          </Grid>
        </MDBox>
        <MDBox pt={2} px={2} lineHeight={1.25}>
          <MDTypography variant="h6" fontWeight="medium">
            Tugas
          </MDTypography>
          <MDBox mb={1}>
            <MDTypography variant="button" color="text">
              Architects design houses
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox p={2}>
          <Grid container spacing={6}>
            {tugas &&
              tugas.map((tugas) => (
                <Grid item xs={12} md={6} xl={3} key={tugas.id}>
                  <DefaultProjectCard
                    image={homeDecor1}
                    label={`Prioritas: ${tugas.tugas.prioritas}`}
                    title={tugas.tugas.judul}
                    description={
                      <MDTypography
                        variant="body2"
                        color="text"
                        sx={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                          maxHeight: "100px",
                          overflow: "auto",
                          "& p": {
                            margin: 0,
                            padding: 0,
                          },
                        }}
                        dangerouslySetInnerHTML={{
                          __html: tugas.tugas.deskripsi,
                        }}
                      />
                    }
                    action={{
                      type: "internal",
                      route: "/pages/profile/profile-overview",
                      color: "info",
                      label: "lihat tugas",
                    }}
                    authors={tugas.penerima_instruksi_yang_sama.map(
                      (penerima) => ({
                        image: penerima.profil,
                        name: penerima.nama,
                      })
                    )}
                  />
                </Grid>
              ))}
          </Grid>
        </MDBox>
      </Header>
      <Footer />
    </DashboardLayout>
  );
}

export default User_Overview;
